import clsx from 'clsx';
import Image, { StaticImageData } from 'next/image';
import { twMerge } from 'tailwind-merge';

interface GuestHeroImageProps {
  src?: StaticImageData | string;
  flag?: React.ReactElement;
  className?: string;
  alt?: string;
  loading?: boolean;
  slipSvgRight?: boolean;
}

const GuestHeroImage: React.FC<GuestHeroImageProps> = ({ src, flag, className, alt, loading = false, slipSvgRight = false }) => (
  <div
    className={twMerge(
      clsx(
        'relative mt-4 aspect-280/267 w-full max-w-sm shrink-0 md:-top-3 lg:mt-0 lg:w-132 lg:max-w-2xl',
        className,
        loading && 'hero-clip animate-pulse bg-gray-200',
      ),
    )}>
    {loading || !src ? null : (
      <Image
        alt={alt || ''}
        className='hero-clip object-cover'
        src={src}
        fill
        priority
        sizes='(max-width: 640px) 50vw, (max-width: 828px) 40vw, (max-width: 1920px) 30vw, (max-width: 2048px) 20vw, 100vw'
      />
    )}
    <svg width={0} height={0} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 280 267'>
      <clipPath id='headerBlobClip' clipPathUnits='objectBoundingBox'>
        <path
          transform={slipSvgRight ? 'translate(1 0) scale(-1 1)' : undefined}
          d='M0.747,0.277 C0.826,0.358,0.925,0.39,0.97,0.463 C1,0.535,1,0.647,0.966,0.737 C0.927,0.827,0.857,0.894,0.783,0.938 C0.71,0.98,0.632,0.999,0.554,1 C0.476,1,0.398,0.984,0.315,0.944 C0.232,0.905,0.144,0.844,0.081,0.744 C0.019,0.644,-0.018,0.507,0.008,0.385 C0.034,0.264,0.122,0.159,0.224,0.086 C0.325,0.014,0.44,-0.026,0.527,0.019 C0.612,0.065,0.669,0.195,0.747,0.277'
        />
      </clipPath>
    </svg>
    {flag ? flag : null}
  </div>
);

export default GuestHeroImage;
